export default "__VITE_ASSET__e6499fb1__"